import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import { TenantImageUpload } from './TenantImageUpload';

export function ImageUploadDialog(props) {
  const { open, onClose, onSuccess, avatarURL } = props;
  const onUploadSuccess = () => {
    onSuccess();
    onClose();
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth={true}>
      <DialogTitle>Set Agency Logo</DialogTitle>
      <DialogContent dividers>
        <TenantImageUpload avatarURL={avatarURL} onSuccess={onUploadSuccess} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

ImageUploadDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  avatarURL: PropTypes.string,
};
